import { createAction } from "redux-actions";

import { SET_SELECTED_PERIOD, SET_START_DATE, SET_END_DATE } from "./types";

const setSelectedPeriod = createAction(SET_SELECTED_PERIOD);
const setStartDate = createAction(SET_START_DATE);
const setEndDate = createAction(SET_END_DATE);

export const selectPeriodRequest = (period) => async (dispatch) => {
  dispatch(setSelectedPeriod(period));
};

export const setStartDateRequest = (startDate) => async (dispatch) => {
  dispatch(setStartDate(startDate));
};

export const setEndDateRequest = (endDate) => async (dispatch) => {
  dispatch(setEndDate(endDate));
};
